<template>
	<div class="work">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0px" v-if="filtershow">
					<el-form-item label="">
						<el-date-picker v-model="formfilter.mydate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
							value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="" prop="shop_id">
						<el-select v-model="formfilter.shop_id" placeholder="请选择渠道">
							<el-option label="渠道" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in qudao" :key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-select v-model="formfilter.work_type" placeholder="工单问题类型">
							<el-option label="工单问题类型" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.buyer_order_work_type"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="">
						<el-input v-model="formfilter.trade_no" placeholder="订单号"></el-input>
					</el-form-item>
					
					<el-form-item label="">
						<el-input v-model="formfilter.work_no" placeholder="工单编号"></el-input>
					</el-form-item>
					
					<el-form-item label="">
						<el-select v-model="formfilter.work_status" placeholder="工单状态">
							<el-option label="工单状态" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="(v,k) in appdata.list.order_work_status"
								:key="k">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow=!filtershow ">
				<span>{{filtershow ? '收起':'展开'}}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%">
					<el-table-column prop="from_type_str" label="发起方" align="center" header-align="center" min-width="60px" fixed="left">
					</el-table-column>
					<el-table-column label="工单编号/订单编号" min-width="140px" align="center" header-align="center">
						<template slot-scope="scope">
							<div @click="oncopy(scope.row.work_no)">{{scope.row.work_no}}</div>
							<div @click="oncopy(scope.row.trade_no)">{{scope.row.trade_no}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="shop_name" label="渠道" align="center" header-align="center" min-width="70px">
					</el-table-column>
					<el-table-column prop="create_time_str" label="工单申请时间" align="center" header-align="center"
						min-width="108px" width="108px">
					</el-table-column>
					<el-table-column prop="work_type_str" label="问题类型" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="buchang" label="补偿金额" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="work_status_str" label="工单状态" align="center" header-align="center"
						min-width="80px">
					</el-table-column>
					<el-table-column prop="wait_time" label="等待时间" align="center" header-align="center" min-width="80px">
					</el-table-column>
					<el-table-column prop="seller_remark" label="备注/备忘/渠道备忘" align="center" header-align="center"
						min-width="150px">
						<template slot-scope="scope">
							<i class="hq el-icon-s-flag" v-if="scope.row.order.seller_mark"
								:style="'color:'+onmark(scope.row.order.seller_mark)"></i>
							<!-- 备注 -->
							<p>{{scope.row.order.seller_remark}}</p>
							<!-- 备忘 -->
							<p :style="'color:'+onmark(scope.row.order.seller_mark)">{{scope.row.order.seller_memo}}</p>
							<!-- 渠道备忘 -->
							<p v-if="scope.row.order.buyer_memo_show_seller == 1">{{scope.row.order.buyer_memo}}</p>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" header-align="center" fixed="right" width="110px">
						<template slot-scope="scope">
							<div class="operation_i"  v-if="scope.row.trade_no">
								<div>
									<span @click="oninfo(scope.row)">详细</span>
									<span @click="onwinfo(scope.row)">处理</span>
								</div>
								<div>
									<el-dropdown @command="handleCommand($event,scope.row.order)" placement="bottom">
										<span>标记</span>
										<el-dropdown-menu slot="dropdown">
											<el-dropdown-item :command="0">取消</el-dropdown-item>
											<el-dropdown-item :command="v.id" v-for="(v,k) in appdata.list.mark"
												:key="k"><i :style="'color:'+v.color">{{v.name}}</i></el-dropdown-item>
										</el-dropdown-menu>
									</el-dropdown>

									<span @click="onmemo(scope.row)">备忘</span>
								</div>
							</div>

							<div class="simg" v-if="scope.row.trade_no">
								<el-tooltip :content="scope.row.qq" placement="bottom" effect="light">
									<img src="../../assets/image/qq.png" @click="oncopy(scope.row.qq)">
								</el-tooltip>
							</div>
							
							<div class="operation_i" v-if="!scope.row.trade_no">
								<div>
									<span @click="onwinfo(scope.row)">处理</span>
								</div>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]" :current-page.sync="page" :page-size="pageSize"
				:total="total" v-if="total > 0" @current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>

		<el-dialog title="订单备忘" :visible.sync="memoVisible" width="60%" :before-close="onclose2">
			<memo ref="memo" :checkobj="checkedobj" v-if="memoVisible" @ondata="onmemodata"></memo>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose2">取消</el-button>
				<el-button type="primary" @click="onsubmemo()">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="订单详情" :visible.sync="detailsVisible" width="80%" :before-close="onclose">
			<orderdetails :checkobj="checkedobj" v-if="detailsVisible"></orderdetails>
		</el-dialog>

		<el-dialog title="发起独立工单" :visible.sync="workVisible" width="80%" :before-close="onclose3">
			<work :isSingle="1" :mydata="{}" ref="work" v-if="workVisible" @onsub="subwork"></work>
			<div slot="footer" class="dialog-footer">
				<el-button @click="onclose3">取消</el-button>
				<el-button type="primary" @click="onsubwork()">确定</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="订单详情" :visible.sync="wdVisible" width="80%" :before-close="onclose4">
			<workdetails :checkobj="checkedobj" v-if="wdVisible" @onload="onbolist()"></workdetails>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Workdiv',
		data() {
			return {
				formfilter: {
					shop_id: "",
					trade_no: "",
					work_type: "",
					work_status: "",
					mydate: [],
					btime: "",
					etime: "",
				},
				list: [],
				filtershow: true,
				page: 1,
				pageSize: 20,
				total: 0,
				checkedobj: {},
				qudao: [],
				memoVisible: false,

				detailsVisible: false,

				workVisible: false,
				
				wdVisible: false
			}
		},

		inject: ['appdata', 'oncopy','formatDate'],

		mounted() {
			this.onqudao();
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect;
					var num = Number(cr.height)+30;
					this.$refs.tablediv.style.height = "calc(100% - "+num+"px)";
				}
			});
			this.resizeObserver.observe(this.$refs.filter);
		},
		
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect();
			}
		},
		
		watch: {
			'$route.query': {
				handler(newQuery, oldQuery) {
					if (Object.keys(this.$route.query).length > 0) {
						for (let key in this.$route.query) {
							if (key == 'work_status') {
								this.formfilter[key] = Number(this.$route.query[key]);
							} else {
								this.formfilter[key] = this.$route.query[key];
							}
						}
					} else {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
						this.formfilter.mydate = [this.formatDate(start), this.formatDate(end)];
					}
					this.onbolist();
				},
				deep: true, // 确保对象内部属性的变化也能被检测到
				immediate: true // 组件创建时立即执行一次handler
			}
		},

		methods: {
			// 基础查询
			handleCurrentChange() {
				this.onbolist();
			},
			
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onbolist();
			},

			onfilter() {
				this.page = 1;
				this.onbolist();
			},

			onreset() {
				this.formfilter = {
					shop_id: "",
					trade_no: "",
					work_type: "",
					work_status: "",
					mydate: [],
					btime: "",
					etime: "",
				};
				this.page = 1;
				this.onbolist();
			},

			onbolist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.btime = obj.mydate[0];
				obj.etime = obj.mydate[1];
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/seller_work_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			//备忘
			onmemo(obj) {
				this.checkedobj = obj.order;
				this.memoVisible = true;
			},

			onclose2() {
				this.checkedobj = {};
				this.memoVisible = false;
			},

			onsubmemo() {
				this.$refs.memo.ondata();
			},

			onmemodata(data) {
				this.$axios.post('api/user/seller_memo', data).then(res => {
					if (res.data.code == 0) {
						this.$message.success('操作成功');
						this.onclose2();
						this.onbolist();
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},


			onmark(id, n) {
				var color = "#000";
				if (this.appdata.list.mark) {
					this.appdata.list.mark.forEach((v, k) => {
						if (v.id == id) {
							color = v.color
						}
					})
				}
				return color;
			},

			handleCommand(val, data) {
				var obj = {
					trade_no: data.trade_no,
					seller_mark: val,
					seller_memo: data.seller_memo,
					seller_memo_show_buyer: data.seller_memo_show_buyer
				};
				this.onmemodata(obj);
			},

			oninfo(obj) {
				this.checkedobj = obj;
				this.detailsVisible = true;
			},

			onclose() {
				this.checkedobj = {};
				this.detailsVisible = false;
			},

			onswork() {
				this.workVisible = true;
			},

			onclose3() {
				this.workVisible = false;
			},

			onsubwork() {
				this.$refs.work.onsubform();
			},

			subwork() {
				this.onclose3();
				this.onbolist();
			},
			
			onwinfo(obj) {
				this.checkedobj = obj;
				this.wdVisible = true;
			},
			
			onclose4() {
				this.checkedobj = {};
				this.wdVisible = false;
			},
			
			onqudao() {
				var obj = {
					code: "",
					name: "",
					state: 2,
					page: 1,
					limit: 99999
				};
			
				this.$axios.post('api/user/shop_list', obj).then(res => {
					if (res.data.code == 0) {
						this.qudao = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
		}
	}
</script>

<style scoped lang="less">
	.work {
		height: 100%;
	}
	.simg {
		width: 100%;
		display: flex;
		justify-content: center;

		img {
			width: 25px;
			height: 25px;
		}
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	.filterty .el-date-editor {
		width: 250px;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/work.vue